/**
 * Session Storage Configuration Service
 * Manages user's preference for local vs remote session storage
 */

const STORAGE_KEY = 'myagent_session_config'

const DEFAULT_CONFIG = {
  storageMode: 'local', // 'local' | 'remote'
}

/**
 * Create session config service
 * @param {Object} storageAdapter - Storage adapter with get/set methods
 * @returns {Object} Config service methods
 */
export function createSessionConfigService(storageAdapter) {
  const getConfig = async () => {
    const stored = await storageAdapter.get(STORAGE_KEY)
    if (!stored) return DEFAULT_CONFIG
    try {
      return JSON.parse(stored)
    } catch {
      return DEFAULT_CONFIG
    }
  }

  const saveConfig = async (config) => {
    await storageAdapter.set(STORAGE_KEY, JSON.stringify(config))
  }

  const isLocalMode = async () => {
    const config = await getConfig()
    return config.storageMode === 'local'
  }

  return {
    getConfig,
    saveConfig,
    isLocalMode,
  }
}
